import { decodeCronExpression } from '@Reports/utils'
import i18n from '@/locales'
import {
  getNameDescriptionTableColumn,
  getProjectDomainTableColumn,
  getTimeTableColumn,
  getEnabledTableColumn,
} from '@/utils/common/tableColumn'
import { getTagTitle } from '@/utils/common/tag'
import {
  getReportElementTypeColumn,
  getReportElementKeyColumn,
} from '../../../utils/columns'

export default {
  data () {
    return {
      columns: [
        getNameDescriptionTableColumn({
          onManager: this.onManager,
          hideField: true,
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
            )
          },
        }),
        {
          title: i18n.t('report.update_frequency'),
          field: 'cron_expression',
          formatter: ({ row }) => {
            const value = decodeCronExpression(row.cron_expression, row.expired_at)
            return value.cycleTypeText + ' ' + value.description
          },
        },
        {
          field: 'elements',
          title: i18n.t('report.report_elements'),
          slots: {
            default: ({ row }) => {
              const columns = [
                {
                  field: 'name',
                  title: i18n.t('common_186'),
                  formatter: ({ row }) => {
                    return row.name ? `${row.index + 1}. ${row.name}` : '-'
                  },
                },
                getReportElementTypeColumn(),
                getReportElementKeyColumn(),
                getProjectDomainTableColumn({ vm: this }),
              ]
              const data = []
              if (this.reportElements.length && row.elements?.length) {
                row.elements.map((item, index) => {
                  const target = this.reportElements.filter(t => t.id === item.id)
                  if (target[0]) {
                    data.push({ ...target[0], index })
                  } else {
                    data.push({ ...item, index })
                  }
                })
              }
              return [<list-body-cell-popover text={this.$t('common_701', [(row.elements || []).length])} min-width="800px">
                <vxe-grid size="mini" border showOverflow={false} row-config={{ isHover: true }} column-config={{ resizable: false }} columns={columns} data={data} />
              </list-body-cell-popover>]
            },
          },
          formatter: ({ row }) => {
            return (row.elements || []).length
          },
        },
        getProjectDomainTableColumn({ vm: this }),
        {
          title: this.$t('report.statistical_object'),
          field: 'target_type',
          slots: {
            default: ({ row }) => {
              const ret = []
              switch (row.target_type) {
                case 'domains':
                  ret.push(this.$t('report.target_type_object.domains'))
                  break
                case 'projects':
                  ret.push(this.$t('report.target_type_object.projects'))
                  break
                case 'domain':
                  ret.push(this.$t('report.target_type_object.domain'))
                  if (row.target_domain) {
                    ret.push(<list-body-cell-wrap copy field='target_domain' hideField row={row}>
                      {row.target_domain}
                    </list-body-cell-wrap>)
                  }
                  break
                case 'project':
                  ret.push(this.$t('report.target_type_object.project'))
                  if (row.target_project) {
                    ret.push(<list-body-cell-wrap copy field='target_project' hideField row={row}>
                      {row.target_project}
                    </list-body-cell-wrap>)
                  }
                  break
                case 'domain_project':
                  ret.push(this.$t('report.target_type_object.domain_project'))
                  if (row.target_domain) {
                    ret.push(<list-body-cell-wrap copy field='target_domain' hideField row={row}>
                      {row.target_domain}
                    </list-body-cell-wrap>)
                  }
                  break
                case 'cloudaccount':
                  ret.push(this.$t('report.target_type_object.cloudaccount'))
                  if (row.target_id) {
                    ret.push(<list-body-cell-wrap copy field='target_id' hideField row={row}>
                      {row.target_id}
                    </list-body-cell-wrap>)
                  }
                  break
                case 'project_metadata':
                  ret.push(this.$t('report.target_type_object.project_metadata'))
                  if (row.target_id) {
                    try {
                      const obj = JSON.parse(row.target_id)
                      const list = []
                      for (const key in obj) {
                        const title = getTagTitle(key, obj[key])
                        list.push(<a-tag style="mr-1 mt-1">{title}</a-tag>)
                      }
                      if (list.length) {
                        ret.push(<div style="width:100%;overflow-x:hidden">{...list}</div>)
                      }
                    } catch (err) {}
                  }
                  break
                case 'domain_server':
                  ret.push(this.$t('report.target_type_object.domain_server'))
                  if (row.target_domain) {
                    ret.push(<list-body-cell-wrap copy field='target_domain' hideField row={row}>
                      {row.target_domain}
                    </list-body-cell-wrap>)
                  }
                  break
                case 'project_server':
                  ret.push(this.$t('report.target_type_object.project_server'))
                  if (row.target_project) {
                    ret.push(<list-body-cell-wrap copy field='target_project' hideField row={row}>
                      {row.target_project}
                    </list-body-cell-wrap>)
                  }
                  break
                default:
                  break
              }
              return ret
            },
          },
          formatter: ({ row }) => {
            let ret = ''
            switch (row.target_type) {
              case 'domains':
                ret = this.$t('report.target_type_object.domains')
                break
              case 'projects':
                ret = this.$t('report.target_type_object.projects')
                break
              case 'domain':
                ret = this.$t('report.target_type_object.domain')
                break
              case 'project':
                ret = this.$t('report.target_type_object.project')
                break
              case 'domain_project':
                ret = this.$t('report.target_type_object.domain_project')
                break
              case 'cloudaccount':
                ret = this.$t('report.target_type_object.cloudaccount')
                break
              case 'project_metadata':
                ret = this.$t('report.target_type_object.project_metadata')
                break
              default:
                break
            }
            return ret
          },
        },
        getEnabledTableColumn(),
        getTimeTableColumn(),
      ],
    }
  },
  methods: {
  },
}
